import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('fruit-market');

const GET_SELLERS = define('GET_SELLERS', true);
const GET_ORDERS = define('GET_ORDERS', true);
const GET_ORDER = define('GET_ORDER', true);
const GET_ORDER_MESSAGES = define('GET_ORDER_MESSAGES', true);
const ADD_NEW_PRODUCT = define('ADD_NEW_PRODUCT', true);
const UPDATE_NEW_PRODUCT = define('UPDATE_NEW_PRODUCT', true);
const GET_CATEGORIES = define('GET_CATEGORIES', true);
const GET_RECOMMENDATION = define('GET_RECOMMENDATION', true);
const CREATE_RECOMMENDATION = define('CREATE_RECOMMENDATION', true);

const initialState = {
  seller: {
    loadingSellers: true,
    sellers: [],
  },
  order: {
    loadingOrders: true,
    orders: [],
    loadingOrder: true,
    order: {},
    loadingOrderMessage: true,
    orderMessages: [],
  },
  product: {
    updating: false,
  },
  categories: {
    categories: [],
    loading: true,
  },
  recommandation: {
    products: null,
    farm: null,
    loading: true,
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SELLERS.PENDING:
      return {
        ...state,
        seller: {
          ...state.seller,
          loadingSellers: true,
          sellers: []
        }
      };
    case GET_SELLERS.RESOLVED:
      return {
        ...state,
        seller: {
          ...state.seller,
          loadingSellers: false,
          sellers: action.data
        }
      };
    case GET_ORDERS.PENDING:
      return {
        ...state,
        order: {
          ...state.order,
          loadingOrders: true,
          orders: [],
        }
      };
    case GET_ORDERS.RESOLVED:
      return {
        ...state,
        order: {
          ...state.order,
          loadingOrders: false,
          orders: action.data,
        }
      };
    case GET_ORDER.PENDING:
      return {
        ...state,
        order: {
          ...state.order,
          loadingOrder: true,
          order: {},
        }
      };
    case GET_ORDER.RESOLVED:
      return {
        ...state,
        order: {
          ...state.order,
          loadingOrder: false,
          order: action.data,
        }
      };
    case GET_ORDER_MESSAGES.PENDING:
      return {
        ...state,
        order: {
          ...state.order,
          loadingOrderMessage: true,
          orderMessages: {},
        }
      };
    case GET_ORDER_MESSAGES.RESOLVED:
      return {
        ...state,
        order: {
          ...state.order,
          loadingOrderMessage: false,
          orderMessages: action.data,
        }
      };
    case ADD_NEW_PRODUCT.PENDING:
      return {
        ...state,
        product: {
          updating: true,
        }
      };
    case ADD_NEW_PRODUCT.RESOLVED:
      return {
        ...state,
        product: {
          updating: false,
        }
      };
    case GET_CATEGORIES.PENDING:
      return {
        ...state,
        categories: {
          loading: true,
          categories: [],
        }
      };
    case GET_CATEGORIES.RESOLVED:
      return {
        ...state,
        categories: {
          loading: false,
          categories: action.data,
        }
      };
    case GET_RECOMMENDATION.PENDING:
      return {
        ...state,
        recommandation: {
          products: null,
          farm: null,
          loading: true,
        }
      };
    case GET_RECOMMENDATION.RESOLVED:
      return {
        ...state,
        recommandation: {
          ...action.data,
          loading: false,
        }
      };
    default: return state;
  }
};

export const actions = {
  getSellers: () => ({
    type: GET_SELLERS,
    promise: api.get('/fruit-market/sellers'),
    error: 'Unable to get fruit market sellers'
  }),
  getOrders: (type) => ({
    type: GET_ORDERS,
    promise: api.get(`/fruit-market/orders?statuses=${type}`),
    error: 'Unable to get fruit market orders'
  }),
  getOrder: (id) => ({
    type: GET_ORDER,
    promise: api.get(`/fruit-market/orders/${id}`),
    error: 'Unable to get fruit market orders'
  }),
  getOrderMessages: (roomId) => ({
    type: GET_ORDER_MESSAGES,
    promise: api.get(`/fruit-market/chat/${roomId}`),
    error: 'Unable to get chat messages'
  }),
  addNewProduct: (body) => ({
    type: ADD_NEW_PRODUCT,
    promise: api.post('/fruit-market/products', body),
    error: 'Unable to create product',
  }),
  updateProduct: (productId, body) => ({
    type: UPDATE_NEW_PRODUCT,
    promise: api.put(`/fruit-market/products/${productId}`, body),
    error: 'Unable to create product',
  }),
  getCategories: () => ({
    type: GET_CATEGORIES,
    promise: api.get('/fruit-market/categories'),
    error: 'Unable to get product categories',
  }),
  getRecommendation: () => ({
    type: GET_RECOMMENDATION,
    promise: api.get('/fruit-market/recommendation'),
    error: 'Unable to get recommendation',
  }),
  createRecommendation: (body) => ({
    type: CREATE_RECOMMENDATION,
    promise: api.post('/fruit-market/recommendation', body),
    success: 'Success',
    error: 'Unable to create recommendation',
  }),
  updateRecommendation: (id, body) => ({
    type: CREATE_RECOMMENDATION,
    promise: api.put(`/fruit-market/recommendation/${id}`, body),
    success: 'Success',
    error: 'Unable to update recommendation',
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/fruit-market.js